module.exports = __webpack_public_path__ + "images/fa-cm-title-hero-mobile.webp";